import { HttpResponseError } from './resolveHttpResponse.js'

export function extractHttpErrorMessage(data) {
  if (!data) {
    return null
  }

  if (typeof data === 'string') {
    return data.trim() || null
  }

  return data?.error?.message || data?.message || data?.errorMessage || null
}

function resolveHttpStatusFromInput(input) {
  if (input === null || input === undefined) {
    return { status: 204, data: null }
  }

  if (input instanceof HttpResponseError) {
    return {
      status: input.status,
      data: input.data,
    }
  }

  if (typeof input?.status === 'number' && !input?.response) {
    return {
      status: input.status,
      data: input.data,
    }
  }

  if (typeof input?.response?.status === 'number') {
    return {
      status: input.response.status,
      data: input.response.data,
    }
  }

  if (input?.code === 'ERR_NETWORK') {
    return {
      status: 0,
      data: null,
    }
  }

  return {
    status: null,
    data: null,
  }
}

const HTTP_ERROR_VIEW_PRESETS = {
  0: {
    severity: 'error',
    titleKey: 'httpErrors.networkError.title',
    messageKey: 'httpErrors.networkError.message',
    showRetry: true,
  },
  204: {
    severity: 'warn',
    titleKey: 'httpErrors.noContent.title',
    messageKey: 'peopleManagement.profileUnavailable',
    showRetry: false,
  },
  400: {
    severity: 'error',
    titleKey: 'httpErrors.badRequest.title',
    messageKey: 'httpErrors.badRequest.message',
    showRetry: false,
  },
  401: {
    severity: 'error',
    titleKey: 'httpErrors.unauthorized.title',
    messageKey: 'httpErrors.unauthorized.message',
    showRetry: false,
  },
  403: {
    severity: 'error',
    titleKey: 'httpErrors.forbidden.title',
    messageKey: 'httpErrors.forbidden.message',
    showRetry: false,
  },
  404: {
    severity: 'error',
    titleKey: 'httpErrors.notFound.title',
    messageKey: 'httpErrors.notFound.message',
    showRetry: false,
  },
  409: {
    severity: 'error',
    titleKey: 'httpErrors.conflict.title',
    messageKey: 'httpErrors.conflict.message',
    showRetry: false,
  },
  422: {
    severity: 'error',
    titleKey: 'httpErrors.validation.title',
    messageKey: 'httpErrors.validation.message',
    showRetry: false,
  },
  429: {
    severity: 'warn',
    titleKey: 'httpErrors.tooManyRequests.title',
    messageKey: 'httpErrors.tooManyRequests.message',
    showRetry: true,
  },
  500: {
    severity: 'error',
    titleKey: 'httpErrors.serverError.title',
    messageKey: 'httpErrors.serverError.message',
    showRetry: true,
  },
  502: {
    severity: 'error',
    titleKey: 'httpErrors.serverError.title',
    messageKey: 'httpErrors.serverError.message',
    showRetry: true,
  },
  503: {
    severity: 'error',
    titleKey: 'httpErrors.serverError.title',
    messageKey: 'httpErrors.serverError.message',
    showRetry: true,
  },
}

const DEFAULT_HTTP_ERROR_VIEW_PRESET = {
  severity: 'error',
  titleKey: 'httpErrors.unexpected.title',
  messageKey: 'httpErrors.unexpected.message',
  showRetry: true,
}

export function resolveHttpErrorViewState(input, overrides = {}) {
  const { status, data } = resolveHttpStatusFromInput(input)
  const preset =
    (typeof status === 'number' && HTTP_ERROR_VIEW_PRESETS[status]) ||
    (typeof status === 'number' && status >= 500
      ? HTTP_ERROR_VIEW_PRESETS[500]
      : DEFAULT_HTTP_ERROR_VIEW_PRESET)

  const apiMessage = extractHttpErrorMessage(data)

  return {
    severity: preset.severity,
    titleKey: preset.titleKey,
    messageKey: apiMessage ? null : preset.messageKey,
    title: overrides.title ?? null,
    message: overrides.message ?? apiMessage,
    status,
    showBack: overrides.showBack ?? true,
    showRetry: overrides.showRetry ?? preset.showRetry ?? false,
    ...overrides,
  }
}
